import { createApp } from 'vue'
import CustomForm from './CustomForm'
import { VueReCaptcha } from 'vue-recaptcha-v3'

const el = ".nyk-component__custom-form";

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {

        DOM.forEach(async (CustomFormDOM) => {
            const formId = CustomFormDOM.children[0].id
            const formGuid = CustomFormDOM.children[0].getAttribute('form-guid')
            const siteKey = CustomFormDOM.children[0].getAttribute('site-key')
            const apiPath = CustomFormDOM.children[0].getAttribute('api-path')
            const antiforgerytoken = CustomFormDOM.children[0].getAttribute('anti-forgery-token')
            const response = await fetch(new Request(`/_forms/v1/forms/${formId}`))
            const formSchemaData = await response.json();
            const formElements = formSchemaData.formElements;
            const component = createApp(CustomForm, {
                formElements,
                showSummarizedData: formSchemaData.properties.showSummarizedData,
                confirmationMessage: formSchemaData.properties.confirmationMessage,
                submitSuccessMessage: formSchemaData.properties.submitSuccessMessage,
                submitErrorMessage: formSchemaData.properties.submitErrorMessage,
                resetAfterSubmission: formSchemaData.properties.resetAfterSubmission,
                formTitle: formSchemaData.properties.title,
                formId,
                formGuid,
                apiPath,
                antiforgerytoken
            }).use(Store)
            component.use(VueReCaptcha, { siteKey })
            component.mount(CustomFormDOM)
        })
    }
}

